// FA-2: one way to write a flight number everywhere ("DL 30", "dl30", "Delta 30", "DL-0030" -> DL30).
// SQL twin: public.fa2_normalize_flight_number (migration 237). Keep the airline list in step with it.

export const AIRLINE_NAMES = Object.freeze([
    ['DL', 'DELTA AIR LINES'], ['DL', 'DELTA AIRLINES'], ['DL', 'DELTA'],
    ['AA', 'AMERICAN AIRLINES'], ['AA', 'AMERICAN'], ['UA', 'UNITED AIRLINES'], ['UA', 'UNITED'],
    ['WN', 'SOUTHWEST AIRLINES'], ['WN', 'SOUTHWEST'], ['B6', 'JETBLUE AIRWAYS'], ['B6', 'JETBLUE'], ['B6', 'JET BLUE'],
    ['NK', 'SPIRIT AIRLINES'], ['NK', 'SPIRIT'], ['F9', 'FRONTIER AIRLINES'], ['F9', 'FRONTIER'],
    ['AS', 'ALASKA AIRLINES'], ['AS', 'ALASKA'], ['G4', 'ALLEGIANT AIR'], ['G4', 'ALLEGIANT'], ['HA', 'HAWAIIAN AIRLINES'],
    ['HA', 'HAWAIIAN'], ['SY', 'SUN COUNTRY'], ['MX', 'BREEZE AIRWAYS'], ['MX', 'BREEZE'], ['AC', 'AIR CANADA'],
    ['WS', 'WESTJET'], ['BA', 'BRITISH AIRWAYS'], ['VS', 'VIRGIN ATLANTIC'], ['AF', 'AIR FRANCE'], ['KL', 'KLM'],
    ['LH', 'LUFTHANSA'], ['AM', 'AEROMEXICO'], ['CM', 'COPA AIRLINES'], ['CM', 'COPA'], ['AV', 'AVIANCA'],
    ['TK', 'TURKISH AIRLINES'], ['EK', 'EMIRATES'], ['QR', 'QATAR AIRWAYS'], ['KE', 'KOREAN AIR'], ['ET', 'ETHIOPIAN AIRLINES'],
    ['LA', 'LATAM'], ['Y4', 'VOLARIS'], ['AZ', 'ITA AIRWAYS'], ['IB', 'IBERIA'], ['EI', 'AER LINGUS'],
].sort((a, b) => b[1].length - a[1].length));

const DESIGNATOR = /^([A-Z][A-Z0-9]|[A-Z0-9][A-Z])([A-Z]?)0*(\d{1,4})([A-Z]?)$/;

/**
 * @param {unknown} value
 * @returns {{ flightNumber: string, airlineCode: string, number: string } | null}
 */
export function parseFlightNumber(value) {
    let text = String(value ?? '').trim().toUpperCase();
    if (!text) return null;
    const named = AIRLINE_NAMES.find(([, name]) => text.startsWith(name) && /^[\s#-]*\d/.test(text.slice(name.length)));
    if (named) text = named[0] + text.slice(named[1].length);
    text = text.replace(/[\s#-]+/g, '');
    const match = text.match(DESIGNATOR);
    if (!match) return null;
    const airlineCode = match[1] + match[2];
    const number = match[3] + match[4];
    return { flightNumber: airlineCode + number, airlineCode, number };
}

/** "Delta 30" -> "DL30"; null when it is not an airline + number. */
export function normalizeFlightNumber(value) {
    return parseFlightNumber(value)?.flightNumber ?? null;
}
